import { render, staticRenderFns } from "./ModifyInfo.vue?vue&type=template&id=55515492&scoped=true&"
import script from "./ModifyInfo.vue?vue&type=script&lang=js&"
export * from "./ModifyInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModifyInfo.vue?vue&type=style&index=0&id=55515492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55515492",
  null
  
)

export default component.exports